import { render, staticRenderFns } from "./AddressFormItem.vue?vue&type=template&id=53c7c961&scoped=true"
import script from "./AddressFormItem.vue?vue&type=script&lang=js"
export * from "./AddressFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7c961",
  null
  
)

export default component.exports